import React, { useState } from "react";
import { Button, Col, Collapse, Row } from "antd";
import {
  AntdDatePicker,
  AntdFormItem,
  AntdInput,
  AntdInputSelect,
  AntdTextArea,
  AntdTreeSelect,
} from "./Component/Component";
import { Controller } from "react-hook-form";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function NewForm({ variations=[], isVariant, customAttributes, control, errors }) {
  console.log(variations);
  const [editor, setEditor] = useState({
    shortDescription: false,
    note: false,
    sizeChart1: false,
    sizeChart2: false,
    materialCare: false,
  });
  return (
    <>
      <Row gutter={16}>
        <Col span={24}>
          <AntdFormItem labelCol={{ span: 24 }} label="Category" errors={errors[""]}>
            {/* <AntdInputSelect
              mode="multiple"
              control={control}
              name={"magento.category"}
              options={customAttributes?.category ?? []}
            /> */}
            <AntdTreeSelect control={control} name={"magento.category"} treeData={customAttributes?.category ?? []} />
          </AntdFormItem>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <AntdFormItem
            labelCol={{ span: 24 }}
            label="Color"
            errors={errors?.magento?.color}
            required={true}
          >
            <AntdInputSelect
              control={control}
              name={"magento.color"}
              options={customAttributes?.color ?? []}
              disabled={isVariant && variations.length > 0 && variations[0].values.length > 0}
            />
          </AntdFormItem>
        </Col>
        <Col span={8}>
          <AntdFormItem labelCol={{ span: 24 }} label="Set Product As New From" errors={errors[""]}>
            <AntdDatePicker control={control} name="magento.news_from_date" />
          </AntdFormItem>
        </Col>
        <Col span={8}>
          <AntdFormItem labelCol={{ span: 24 }} label="Set Product As New To" errors={errors[""]}>
            <AntdDatePicker control={control} name="magento.news_to_date" />
          </AntdFormItem>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <AntdFormItem
            labelCol={{ span: 24 }}
            label="Material"
            errors={errors?.magento?.material}
            required={true}
          >
            <AntdInputSelect
              control={control}
              name={"magento.material"}
              options={customAttributes?.material ?? []}
            />
          </AntdFormItem>
        </Col>
        <Col span={8}>
          <AntdFormItem
            labelCol={{ span: 24 }}
            label="Type"
            errors={errors?.magento?.type}
            required={true}
          >
            <AntdInputSelect
              mode="multiple"
              control={control}
              name={"magento.type"}
              options={customAttributes?.type ?? []}
            />
          </AntdFormItem>
        </Col>
        <Col span={8}>
          <AntdFormItem labelCol={{ span: 24 }} label="Size" errors={errors[""]}>
            <AntdInputSelect
              control={control}
              name={"magento.size"}
              options={customAttributes?.size ?? []}
              disabled={isVariant && variations.length > 1 && variations[1].values.length > 0}
            />
          </AntdFormItem>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <AntdFormItem labelCol={{ span: 24 }} label="Related Products" errors={errors[""]}>
            <AntdInputSelect
              control={control}
              mode="multiple"
              name={"magento.relatedProducts"}
              options={customAttributes?.product ?? []}
            />
          </AntdFormItem>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Controller
            name={"magento.short_description"}
            control={control}
            render={({ field }) => (
              <AntdFormItem labelCol={{ span: 24 }} label="Short Description" errors={errors[""]}>
                <Button
                  type="success"
                  onClick={() => {
                    setEditor((prev) => ({
                      ...prev,
                      shortDescription: !prev.shortDescription,
                    }));
                    //field.onChange("");
                  }}
                >
                  Show / Hide Editor
                </Button>
                {editor.shortDescription === false ? (
                  <ReactQuill
                    theme="snow"
                    onChange={(v) => {
                      field.onChange(v);
                    }}
                    value={field.value}
                  />
                ) : (
                  <AntdTextArea
                    autoSize={{ minRows: 10 }}
                    control={control}
                    name="magento.short_description"
                  />
                )}
              </AntdFormItem>
            )}
          />
        </Col>
      </Row>
      <Collapse style={{ marginBottom: "10px" }} defaultActiveKey={["1"]}>
        <Collapse.Panel header="Fabric Guide" key="1">
          <Row gutter={16}>
            <Col span={8}>
              <AntdFormItem
                labelCol={{ span: 24 }}
                label="Opacity"
                errors={errors?.magento?.opacity}
                required={true}
              >
                <AntdInputSelect
                  control={control}
                  name={"magento.opacity"}
                  options={customAttributes?.opacity ?? []}
                />
              </AntdFormItem>
            </Col>
            <Col span={8}>
              <AntdFormItem
                labelCol={{ span: 24 }}
                label="Texture"
                errors={errors?.magento?.texture}
                required={true}
              >
                <AntdInputSelect
                  control={control}
                  name={"magento.texture"}
                  options={customAttributes?.texture ?? []}
                />
              </AntdFormItem>
            </Col>
            <Col span={8}>
              <AntdFormItem
                labelCol={{ span: 24 }}
                label="Thickness"
                errors={errors?.magento?.thickness}
                required={true}
              >
                <AntdInputSelect
                  control={control}
                  name={"magento.thickness"}
                  options={customAttributes?.thickness ?? []}
                />
              </AntdFormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Controller
                name={"magento.note"}
                control={control}
                render={({ field }) => (
                  <AntdFormItem labelCol={{ span: 24 }} label="Notes" errors={errors[""]}>
                    <Button
                      type="success"
                      onClick={() => {
                        setEditor((prev) => ({
                          ...prev,
                          note: !prev.note,
                        }));
                        //field.onChange("");
                      }}
                    >
                      Show / Hide Editor
                    </Button>
                    {editor.note === false ? (
                      <ReactQuill
                        theme="snow"
                        onChange={(v) => {
                          field.onChange(v);
                        }}
                        value={field.value}
                      />
                    ) : (
                      <AntdTextArea
                        autoSize={{ minRows: 10 }}
                        control={control}
                        name="magento.note"
                      />
                    )}
                  </AntdFormItem>
                )}
              />
            </Col>
          </Row>
        </Collapse.Panel>
      </Collapse>
      <Collapse style={{ marginBottom: "10px" }}>
        <Collapse.Panel header="Size Chart" key="1">
          <Row gutter={16}>
            <Col span={24}>
              <Controller
                name={"magento.sizeChart.size_chart_inch"}
                control={control}
                render={({ field }) => (
                  <AntdFormItem
                    labelCol={{ span: 24 }}
                    label="Size Chart (Inch)"
                    errors={errors[""]}
                  >
                    <Button
                      type="success"
                      onClick={() => {
                        setEditor((prev) => ({
                          ...prev,
                          sizeChart1: !prev.sizeChart1,
                        }));
                        //field.onChange("");
                      }}
                    >
                      Show / Hide Editor
                    </Button>
                    {editor.sizeChart1 === false ? (
                      <ReactQuill
                        theme="snow"
                        onChange={(v) => {
                          field.onChange(v);
                        }}
                        value={field.value}
                      />
                    ) : (
                      <AntdTextArea
                        autoSize={{ minRows: 10 }}
                        control={control}
                        name="magento.sizeChart.size_chart_inch"
                      />
                    )}
                  </AntdFormItem>
                )}
              />
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Controller
                name={"magento.sizeChart.size_chart_cm"}
                control={control}
                render={({ field }) => (
                  <AntdFormItem labelCol={{ span: 24 }} label="Size Chart (CM)" errors={errors[""]}>
                    <Button
                      type="success"
                      onClick={() => {
                        setEditor((prev) => ({
                          ...prev,
                          sizeChart2: !prev.sizeChart2,
                        }));
                        //field.onChange("");
                      }}
                    >
                      Show / Hide Editor
                    </Button>
                    {editor.sizeChart2 === false ? (
                      <ReactQuill
                        theme="snow"
                        onChange={(v) => {
                          field.onChange(v);
                        }}
                        value={field.value}
                      />
                    ) : (
                      <AntdTextArea
                        autoSize={{ minRows: 10 }}
                        control={control}
                        name="magento.sizeChart.size_chart_cm"
                      />
                    )}
                  </AntdFormItem>
                )}
              />
            </Col>
          </Row>
        </Collapse.Panel>
      </Collapse>
      <Collapse style={{ marginBottom: "10px" }}>
        <Collapse.Panel header="Material Care" key="1">
          <Row gutter={16}>
            <Col span={24}>
              <Controller
                name={"magento.materialCare.material_care"}
                control={control}
                render={({ field }) => (
                  <AntdFormItem labelCol={{ span: 24 }} label="Material Care" errors={errors[""]}>
                    <Button
                      type="success"
                      onClick={() => {
                        setEditor((prev) => ({
                          ...prev,
                          materialCare: !prev.materialCare,
                        }));
                        //field.onChange("");
                      }}
                    >
                      Show / Hide Editor
                    </Button>
                    {editor.materialCare === false ? (
                      <ReactQuill
                        theme="snow"
                        onChange={(v) => {
                          field.onChange(v);
                        }}
                        value={field.value}
                      />
                    ) : (
                      <AntdTextArea
                        autoSize={{ minRows: 10 }}
                        control={control}
                        name="magento.materialCare.material_care"
                      />
                    )}
                  </AntdFormItem>
                )}
              />
            </Col>
          </Row>
        </Collapse.Panel>
      </Collapse>
      <Collapse style={{ marginBottom: "10px" }}>
        <Collapse.Panel header="Search Engine Optimization" key="1">
          <Row gutter={16}>
            <Col span={12}>
              <AntdFormItem labelCol={{ span: 24 }} label="Url Key" errors={errors[""]}>
                <AntdInput control={control} name={"magento.seo.url_key"} />
              </AntdFormItem>
            </Col>
            <Col span={12}>
              <AntdFormItem labelCol={{ span: 24 }} label="Meta Title" errors={errors[""]}>
                <AntdInput control={control} name={"magento.seo.meta_title"} />
              </AntdFormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <AntdFormItem labelCol={{ span: 24 }} label="Meta Keywords" errors={errors[""]}>
                <AntdTextArea control={control} name={"magento.seo.meta_keyword"} />
              </AntdFormItem>
            </Col>
            <Col span={12}>
              <AntdFormItem labelCol={{ span: 24 }} label="Meta Description" errors={errors[""]}>
                <AntdTextArea control={control} name={"magento.seo.meta_description"} />
              </AntdFormItem>
            </Col>
          </Row>
        </Collapse.Panel>
      </Collapse>
    </>
  );
}
